import { PJAxios, PJLinkSalto, sendLogin, useLanguage, usePJStore, useUserInfo } from '@jaf/jaf-react-core';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import FormRow from '../Common/FormRow';


function ReactInoltraFormConfig(props) {

    const toast = useRef(null);
    const getText = usePJStore((state) => state.i18n_getText)
    const params = usePJStore((state) => state.params)
    
    const cognome = usePJStore((state) => state.userInfo_cognome)
    const nome = usePJStore((state) => state.userInfo_nome)
    const email = usePJStore((state) => state.userInfo_email)
    const codice_persona = usePJStore((state) => state.userInfo_codice_persona)
    

    const isLogged = useUserInfo() != null;
    const { storage } = usePJStore((state) => state.storage)
    const language = useLanguage();

    const programmaManifestazioneFileUploadRef = useRef(null);
    const progettoPreliminareFileUploadRef = useRef(null);

    const [selectedQueue,setSelectedQueue] = useState(null)

    const [selectedNodeId, setSelectedNodeId] = useState(params != null ? params.selectedNodeId : "");
    const [titolo, setTitolo] = useState(params != null ? params.titolo : "");
    const [descrizione, setDescrizione] = useState(params != null ? params.descrizione : "");
    const [selectedCarattereAttivita, setSelectedCarattereAttivita] = useState(null)
    const [carattereAttivitaText, setCarattereAttivitaText] = useState(params != null ? params.carattereAttivitaText : "")
    const [selectedTipoSpaziRichiesti, setSelectedTipoSpaziRichiesti] = useState(null)
    const [dataAllestimento, setDataAllestimento] = useState(params != null ? params.dataAllestimento : null)
    const [dataDisallestimento, setDataDisallestimento] = useState(params != null ? params.dataDisallestimento : null)
    const [numeroAule, setNumeroAule] = useState(params != null ? params.numeroAule : 0)
    const [numeroPartecipantiPrevisti, setNumeroPartecipantiPrevisti] = useState(params != null ? params.numeroPartecipantiPrevisti : 0)

    const [coinvolteEntitaEsterne, setCoinvolteEntitaEsterne] = useState(params != null && params.coinvolteEntitaEsterne === "true")
    const [descrizioneEntitaEsterne, setDescrizioneEntitaEsterne] = useState(params != null ? params.descrizioneEntitaEsterne : "")

    const [assicurazioneMaterialeEsposto, setAssicurazioneMaterialeEsposto] = useState(params != null && params.assicurazioneMaterialeEsposto === "true")
    const [attrezzaturaAudioVideo, setAttrezzaturaAudioVideo] = useState(params != null && params.attrezzaturaAudioVideo === "true")
    const [assistenzaAudioVideo, setAssistenzaAudioVideo] = useState(params != null && params.assistenzaAudioVideo === "true")
    const [registrazioneEvento, setRegistrazioneEvento] = useState(params != null && params.registrazioneEvento === "true")
    const [credenzialiWifi, setCredenzialiWifi] = useState(params != null && params.credenzialiWifi === "true")
    const [presidioPulizie, setPresidioPulizie] = useState(params != null && params.presidioPulizie === "true")
    const [presidioSorveglianza, setPresidioSorveglianza] = useState(params != null && params.presidioSorveglianza === "true")
    const [servizioFacchinaggio, setServizioFacchinaggio] = useState(params != null && params.servizioFacchinaggio === "true")

    const [assicurazioneMaterialeEspostoDesc, setAssicurazioneMaterialeEspostoDesc] = useState("")
    const [attrezzaturaAudioVideoDesc, setAttrezzaturaAudioVideoDesc] = useState("")
    const [assistenzaAudioVideoDesc, setAssistenzaAudioVideoDesc] = useState("")
    const [registrazioneEventoDesc, setRegistrazioneEventoDesc] = useState("")
    const [credenzialiWifiDesc, setCredenzialiWifiDesc] = useState("")
    const [presidioPulizieDesc, setPresidioPulizieDesc] = useState("")
    const [presidioSorveglianzaDesc, setPresidioSorveglianzaDesc] = useState("")
    const [servizioFacchinaggioDesc, setServizioFacchinaggioDesc] = useState("")


    const [unitaOrganizzativaText, setUnitaOrganizzativaText] = useState(params != null ? params.unitaOrganizzativaText : "")
    const [selectedUnitaOrganizzativa, setSelectedUnitaOrganizzativa] = useState(null)

    const [inputNomeObj, setInputNomeObj] = useState(null);
    const [selectGruppoVisObj, setSelectGruppoVisObj] = useState(null);
    const [selectAccessoObj, setSelectAccessoObj] = useState(null);

    const [lookup_id_persona, setLookup_id_persona] = useState(params.lookup_id_persona)
    const [userResponsabileInfo, setUserResponsabileInfo] = useState(null)
    

    const [strutture, setStrutture] = useState([])
    const [selectedStruttura, setSelectedStruttura] = useState(null)
    const [selectedTipologiaAttivita, setSelectedTipologiaAttivita] = useState(null)

    const [progettoPreliminare, setProgettoPreliminare] = useState(null)
    const [programmaManifestazione, setProgrammaManifestazione] = useState(null)

    const [ticketSent, setTicketSent] = useState(false)

    const [loading, setLoading] = useState(false)


    const attivitaList = [
        { name: getText("ATTIVITA_CULTURALE"), code: 'C' },
        { name: getText("ATTIVITA_SCIENTIFICA"), code: 'S' },
        { name: getText("ATTIVITA_ALTRA"), code: 'A' },
    ];

    const unitaOrganizzativeList = [
        { name: getText("STRUTTURA"), code: 'STR' },
        { name: getText("ENTE"), code: 'E' },
        { name: getText("SOCIETA"), code: 'SOC' },
        { name: getText("ASSOCIAZIONE_STUDENTESCA"), code: 'A' },
        { name: getText("GRUPPO_STUDENTI"), code: 'GS' },
    ];
    const sediList = [
        { name: getText("CITTA_STUDI"), code: 'MI', queue: '[OQ:AGIS::Eventi::Leonardo]' },
        { name: getText("BOVISA"), code: 'BO' , queue: '[OQ:AGIS::Eventi::Bovisa]' }
    ];

    const tipoSpaziRichiestiList = [
        { name: getText("AULE"), code: 'A' },
        { name: getText("AULE_INFORMATIZZATE"), code: 'AI' },
        { name: getText("AULE_CONVEGNI"), code: 'AC' },
        { name: getText("SPAZI_ESPOSITIVI"), code: 'SE' }
    ];

    const tipologiaAttivitaList = [
        { name: getText("ATTIVITA_FINANZIATA"), code: 'F' },
        { name: getText("ATTIVITA_NON_FINANZIATA"), code: 'NF' }
    ];



    useEffect(() => {
        if (!isLogged) {
            sendLogin();
        }
    }, []);

    useEffect(() => {
        attivitaList.forEach((item) => {
            if (item.code == params.selectedCarattereAttivita) {
                setSelectedCarattereAttivita(item)
            }
        })
    }, [params.selectedCarattereAttivita]);

    useEffect(() => {
        unitaOrganizzativeList.forEach((item) => {
            if (item.code == params.selectedUnitaOrganizzativa) {
                setSelectedUnitaOrganizzativa(item)
            }
        })
    }, [params.selectedUnitaOrganizzativa]);

    useEffect(() => {
        sediList.forEach((item) => {
            if (item.code == params.selectedQueue) {
                setSelectedQueue(item)
            }
        })
    }, [params.selectedQueue]);


    useEffect(() => {
        strutture.forEach((item) => {
            if (item.ID_STRUTTURA == params.selectedStruttura) {
                setSelectedStruttura(item)
            }
        })
    }, [strutture]);

    useEffect(() => {
        tipoSpaziRichiestiList.forEach((item) => {
            if (item.code == params.selectedTipoSpaziRichiesti) {
                setSelectedTipoSpaziRichiesti(item)
            }
        })
    }, [params.selectedTipoSpaziRichiesti]);

    useEffect(() => {
        if (lookup_id_persona != null) {
            var url = '/nuovaRichiesta/getUserInfo';
            PJAxios().post(url, { idPersona: lookup_id_persona }).then((res) => {
                setUserResponsabileInfo(res.data)
            })
        }

    }, [lookup_id_persona]);

    useEffect(() => {
        loadStruttureFromDb();

    }, [selectedUnitaOrganizzativa]);

    const loadStruttureFromDb = () => {
        if (selectedUnitaOrganizzativa != null && selectedUnitaOrganizzativa.code === 'STR') {
            var url = '/nuovaRichiesta/getStrutture';
            PJAxios().get(url).then((res) => {
                setStrutture(res.data)
            })
        }
    }

    const progettoPreliminareBase64Uploader = async (event) => {
        // convert file to base64 encoded
        const file = event.files[0];

        const reader = new FileReader();
        reader.readAsBinaryString(file);


        reader.onloadend = function (e) {
            if (file.size < 2500000) {

                let b64payload = btoa(e.target.result);
                setProgettoPreliminare({ data: b64payload, name: "PROGETTO_PRELIMINARE_" + file.name, size: file.size, type: file.type })
                progettoPreliminareFileUploadRef.current.clear();
            } else {
                toast.current.show({ severity: 'error', life:10000, summary: getText("INFORMAZIONE"), detail: getText("FILE_BIGGER_THAN_ALLOWED") });
                progettoPreliminareFileUploadRef.current.clear();
            }
        };
    };



    const programmaManifestazioneBase64Uploader = async (event) => {

        const file = event.files[0];

        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onloadend = function (e) {
            if (file.size < 2500000) {
                let b64payload = btoa(e.target.result);
                const content = e.target.result;
                setProgrammaManifestazione({ data: b64payload, name: "PROGRAMMA_MANIFESTAZIONE_" + file.name, size: file.size, type: file.type })
                programmaManifestazioneFileUploadRef.current.clear();
            } else {
                toast.current.show({ severity: 'error', life:10000, summary: getText("INFORMAZIONE"), detail: getText("FILE_BIGGER_THAN_ALLOWED") });
                programmaManifestazioneFileUploadRef.current.clear();
            }

        };
    };

    const createNewTicket = () => {
        setTicketSent(false)
        setTitolo("")

        setSelectedCarattereAttivita(null)
        setSelectedStruttura(null)
        setSelectedTipoSpaziRichiesti(null)
        setSelectedTipologiaAttivita(null)
        setSelectedUnitaOrganizzativa(null)
        setSelectedQueue(null)
        setAssicurazioneMaterialeEsposto(false)
        setAssistenzaAudioVideo(false)
        setAttrezzaturaAudioVideo(false)
        setCarattereAttivitaText("")
        setCoinvolteEntitaEsterne(false)
        setCredenzialiWifi(false)
        setDataAllestimento(null)
        setDataDisallestimento(null)
        setDescrizione("")
        setDescrizioneEntitaEsterne("")
        setLookup_id_persona(null)
        setNumeroAule(null)
        setNumeroPartecipantiPrevisti(null)
        setPresidioPulizie(false)
        setPresidioSorveglianza(false)
        setProgettoPreliminare(null)
        setProgrammaManifestazione(null)
        setRegistrazioneEvento(false)
        setServizioFacchinaggio(false)
        setUnitaOrganizzativaText("")
        setUserResponsabileInfo(null)

    }

    const sendTicket = () => {

        const params = {
            user: {
                codice_persona: codice_persona
            },
            selectedUnitaOrganizzativa,
            selectedQueue,
            unitaOrganizzativaText,
            selectedStruttura: {
                id_struttura: selectedStruttura != null ? selectedStruttura.ID_STRUTTURA : null,
                struttura_dn: selectedStruttura != null ? selectedStruttura.STRUTTURA_DN : null,
                struttura_dn_eng: selectedStruttura != null ? selectedStruttura.STRUTTURA_DN_ENG : null,
            },
            selectedTipologiaAttivita,
            userResponsabileInfo,
            titolo,
            descrizione,
            programmaManifestazione,
            selectedCarattereAttivita,
            carattereAttivitaText,
            selectedTipoSpaziRichiesti,
            dataAllestimento,
            dataDisallestimento,
            progettoPreliminare,
            numeroAule,
            numeroPartecipantiPrevisti,
            coinvolteEntitaEsterne,
            descrizioneEntitaEsterne,
            assicurazioneMaterialeEsposto,
            attrezzaturaAudioVideo,
            assistenzaAudioVideo,
            registrazioneEvento,
            credenzialiWifi,
            presidioSorveglianza,
            presidioPulizie,
            servizioFacchinaggio,
            selectedNodeId,
            assicurazioneMaterialeEspostoDesc,
            attrezzaturaAudioVideoDesc,
            assistenzaAudioVideoDesc,
            registrazioneEventoDesc,
            credenzialiWifiDesc,
            presidioSorveglianzaDesc,
            presidioPulizieDesc,
            servizioFacchinaggioDesc

        }
        var url = '/nuovaRichiesta/sendGestioneEventiTicket';
        setLoading(true)
        PJAxios().post(url, params).then((res) => {
            setTicketSent(res.data)
            if (res.data) {
                toast.current.show({ severity: 'success', summary: getText("INFORMAZIONE"), detail: getText("TICKET_CREATED_SUCCESSFULLY") });
            } else {
                toast.current.show({ severity: 'danger', summary: getText("INFORMAZIONE"), detail: getText("ERROR_CREATING_TICKET") });
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    const validForm = () => {
        /*
                console.log({
                   user,
                   selectedUnitaOrganizzativa,
                   unitaOrganizzativaText,
                   selectedStruttura,
                   selectedTipologiaAttivita,
                   userResponsabileInfo,
                   titolo,
                   descrizione,
                   programmaManifestazione,
                   selectedCarattereAttivita,
                   carattereAttivitaText,
                   selectedTipoSpaziRichiesti,
                   dataAllestimento,
                   dataDisallestimento,
                   progettoPreliminare,
                   numeroAule,
                   numeroPartecipantiPrevisti,
                   coinvolteEntitaEsterne,
                   descrizioneEntitaEsterne,
                   assicurazioneMaterialeEsposto,
                   attrezzaturaAudioVideo,
                   assistenzaAudioVideo,
                   registrazioneEvento,
                   credenzialiWifi,
                   presidioSorveglianza,
                   presidioPulizie,
                   servizioFacchinaggio,
                   selectedNodeId
       
               })
       */
        var valid = selectedUnitaOrganizzativa != null &&
            ((selectedUnitaOrganizzativa.code === 'A' && selectedTipologiaAttivita != null) || (selectedUnitaOrganizzativa.code === 'GS' && selectedTipologiaAttivita != null) || (selectedUnitaOrganizzativa.code === 'STR' && selectedStruttura != null) || (selectedUnitaOrganizzativa.code !== 'STR' && selectedUnitaOrganizzativa.code !== 'A' && unitaOrganizzativaText != null && unitaOrganizzativaText.length > 0)) &&
            titolo != null && titolo.length > 0 &&
            descrizione != null && descrizione.length > 0 &&
            programmaManifestazione != null &&
            (selectedCarattereAttivita != null || (selectedCarattereAttivita != null && selectedCarattereAttivita.code == "A" && (carattereAttivitaText != null && carattereAttivitaText.length > 0))) &&
            (selectedTipoSpaziRichiesti != null || (selectedTipoSpaziRichiesti != null && selectedTipoSpaziRichiesti.code == "SE" && progettoPreliminare != null && dataAllestimento != undefined && dataDisallestimento != undefined && dataAllestimento.be)) &&
            (numeroAule != null) &&
            (numeroPartecipantiPrevisti != null) &&
            (selectedQueue != null) &&
            (isFalseOrDescriptionFilled(assicurazioneMaterialeEsposto,assicurazioneMaterialeEspostoDesc)) &&
            (isFalseOrDescriptionFilled(attrezzaturaAudioVideo,attrezzaturaAudioVideoDesc)) &&
            (isFalseOrDescriptionFilled(assistenzaAudioVideo,assistenzaAudioVideoDesc)) &&
            (isFalseOrDescriptionFilled(registrazioneEvento,registrazioneEventoDesc)) &&
            (isFalseOrDescriptionFilled(credenzialiWifi,credenzialiWifiDesc)) &&
            (isFalseOrDescriptionFilled(presidioPulizie,presidioPulizieDesc)) &&
            (isFalseOrDescriptionFilled(presidioSorveglianza,presidioSorveglianzaDesc)) &&
            (isFalseOrDescriptionFilled(servizioFacchinaggio,servizioFacchinaggioDesc))
            ;

        /*
    try{
         //console.log(selectedUnitaOrganizzativa != null)
         //console.log(((selectedUnitaOrganizzativa.code === 'A' && selectedTipologiaAttivita != null) || (selectedUnitaOrganizzativa.code === 'STR' && selectedStruttura != null) || (selectedUnitaOrganizzativa.code !== 'STR' && selectedUnitaOrganizzativa.code !== 'A' && unitaOrganizzativaText != null && unitaOrganizzativaText.length > 0)))
         //console.log(titolo != null && titolo.length > 0)
         //console.log(descrizione != null && descrizione.length > 0)
         //console.log(programmaManifestazione != null)
         //console.log((selectedCarattereAttivita != null || (selectedCarattereAttivita != null && selectedCarattereAttivita.code == "A" && (carattereAttivitaText != null && carattereAttivitaText.length > 0))))
         //console.log((selectedTipoSpaziRichiesti != null || (selectedTipoSpaziRichiesti != null && selectedTipoSpaziRichiesti.code == "SE" && progettoPreliminare != null && dataAllestimento != undefined && dataDisallestimento != undefined && dataAllestimento.be)))
         //console.log((numeroAule != null))
         //console.log((numeroPartecipantiPrevisti != null ))
    }catch(e){

    } */



        return valid;
    }

    const isFalseOrDescriptionFilled = (s,desc) => {
        return s == false || (s == true && desc != null && desc.length > 0)
    }

    return (
        <>
            <Toast ref={toast} position="top-right" />
            <Card title={getText("INFORMAZIONI_EVENTO")}>

                <FormRow left={getText("FORM_CUSTOMER")} right={cognome + " " + nome} />
                <FormRow left={getText("EMAIL")} right={email} />
                <FormRow left={getText("SEDE_EVENTO")} right={<Dropdown disabled={ticketSent} value={selectedQueue} onChange={(e) => setSelectedQueue(e.value)} options={sediList} optionLabel="name" placeholder={getText("PLEASE_SELECT")} className="w-full md:w-14rem" />} />
                <FormRow left={getText("UNITA_ORGANIZZATIVA")} right={<Dropdown disabled={ticketSent} value={selectedUnitaOrganizzativa} onChange={(e) => setSelectedUnitaOrganizzativa(e.value)} options={unitaOrganizzativeList} optionLabel="name" placeholder={getText("PLEASE_SELECT")} className="w-full md:w-14rem" />} />
                {selectedUnitaOrganizzativa != null && selectedUnitaOrganizzativa.code !== 'STR' && selectedUnitaOrganizzativa.code !== 'GS' &&
                    <FormRow left={getText("UNITA_ORGANIZZATIVA_DIGITA")} right={<InputText disabled={ticketSent} style={{ width: "100%" }} value={unitaOrganizzativaText} onChange={(e) => setUnitaOrganizzativaText(e.target.value)} />} />
                }
                {selectedUnitaOrganizzativa != null && (selectedUnitaOrganizzativa.code === 'A' || selectedUnitaOrganizzativa.code === 'GS') &&
                    <FormRow left={getText("SELEZIONA_TIPOLOGIA_ATTIVITA")} right={<Dropdown disabled={ticketSent} style={{ width: "18em" }} value={selectedTipologiaAttivita} onChange={(e) => setSelectedTipologiaAttivita(e.value)} options={tipologiaAttivitaList} optionLabel="name" placeholder={getText("PLEASE_SELECT")} className="w-full md:w-14rem" />} />
                }

                {selectedUnitaOrganizzativa != null && selectedUnitaOrganizzativa.code === 'STR' &&
                    <FormRow left={getText("SELEZIONA_STRUTTURA")} right={<Dropdown disabled={ticketSent} style={{ width: "18em" }} value={selectedStruttura} onChange={(e) => setSelectedStruttura(e.value)} options={strutture} optionLabel={language == 'IT' ? "STRUTTURA_DN" : "STRUTTURA_DN_ENG"} placeholder={getText("PLEASE_SELECT")} />} />
                }

                <FormRow left={getText("RESPONSABILE_EVENTO")} right={<div className='col-12 formgroup-inline'>
                    {userResponsabileInfo != null &&
                        <div className='col-12'>
                            {userResponsabileInfo.cognome + " " + userResponsabileInfo.nome + " (" + userResponsabileInfo.codicePersona + ")"}

                        </div>

                    }

                    <div className='col-12'>
                        <PJLinkSalto disabled={ticketSent}
                            id_servizio="464"
                            label={getText("LBL_SELEZIONA")}
                            type="button"
                            returnParams={{
                                nuovaRichiesta: true,
                                formType: "ReactInoltraFormConfig",
                                selectedNodeId,
                                selectedUnitaOrganizzativa: selectedUnitaOrganizzativa != null ? selectedUnitaOrganizzativa.code : null,
                                selectedQueue: selectedQueue != null ? selectedQueue.code : null,
                                unitaOrganizzativaText,
                                selectedStruttura: selectedStruttura != null ? selectedStruttura.ID_STRUTTURA : null,
                                titolo,
                                descrizione,
                                selectedCarattereAttivita: selectedCarattereAttivita != null ? selectedCarattereAttivita.code : null,
                                carattereAttivitaText,
                                selectedTipoSpaziRichiesti: selectedTipoSpaziRichiesti != null ? selectedTipoSpaziRichiesti.code : null,
                                dataAllestimento,
                                dataDisallestimento,
                                numeroAule,
                                numeroPartecipantiPrevisti,
                                assicurazioneMaterialeEsposto,
                                attrezzaturaAudioVideo,
                                assistenzaAudioVideo,
                                registrazioneEvento,
                                credenzialiWifi,
                                presidioPulizie,
                                presidioSorveglianza,
                                servizioFacchinaggio,
                                coinvolteEntitaEsterne,
                                descrizioneEntitaEsterne
                            }}></PJLinkSalto>
                    </div>

                </div>
                } />

                <FormRow left={getText("TITOLO_EVENTO")} right={<InputText onChange={(e) => setTitolo(e.target.value)} disabled={ticketSent} style={{ width: "100%" }} value={titolo} className={titolo != null && titolo.length == 0 ? 'p-invalid' : ""} />} />
                <FormRow left={getText("BREVE_DESCRIZIONE")} right={<InputTextarea disabled={ticketSent} style={{ width: "100%" }} rows={5} cols={50} value={descrizione} onChange={(e) => setDescrizione(e.target.value)} className={descrizione != null && descrizione.length == 0 ? 'p-invalid' : ""} />} />
                <FormRow left={getText("PROGRAMMA_MANIFESTAZIONE")} right={<div className='col-12 formgroup-inline'>
                    <div className='col-12'>
                        <FileUpload disabled={ticketSent} ref={programmaManifestazioneFileUploadRef} mode="basic" customUpload uploadHandler={programmaManifestazioneBase64Uploader} name="demo[]" accept="application/pdf" maxFileSize={10000000} />
                    </div>
                    <div className='col-12'>
                        {programmaManifestazione != null && (programmaManifestazione.name + "(" + programmaManifestazione.size + " bytes)")}
                    </div>
                </div>
                } />

                <FormRow left={getText("CARATTERE_ATTIVITA")} right={
                    <div className='col-12 formgroup-inline'>
                        <div className='col-12'>
                            <Dropdown disabled={ticketSent} value={selectedCarattereAttivita} onChange={(e) => setSelectedCarattereAttivita(e.value)} options={attivitaList} optionLabel="name" placeholder={getText("PLEASE_SELECT")} className="w-full md:w-14rem" />
                        </div>
                        {selectedCarattereAttivita != null && selectedCarattereAttivita.code == "A" &&
                            <div className='col-12'>
                                <InputText disabled={ticketSent} style={{ width: "100%" }} value={carattereAttivitaText} onChange={(e) => setCarattereAttivitaText(e.target.value)} placeholder={getText("SPECIFY")} />
                            </div>


                        }
                    </div>
                } />

                <FormRow left={getText("TIPO_SPAZI_RICHIESTI")} right={<Dropdown disabled={ticketSent} value={selectedTipoSpaziRichiesti} onChange={(e) => setSelectedTipoSpaziRichiesti(e.value)} options={tipoSpaziRichiestiList} optionLabel="name" placeholder={getText("PLEASE_SELECT")} className="w-full md:w-14rem" />} />

                {selectedTipoSpaziRichiesti != null && selectedTipoSpaziRichiesti.code == "SE" &&
                    <>
                        <FormRow left={getText("DATA_ALLESTIMENTO")} right={<Calendar disabled={ticketSent} value={dataAllestimento} onChange={(e) => setDataAllestimento(e.value)} />} />
                        <FormRow left={getText("DATA_DISALLESTIMENTO")} right={<Calendar disabled={ticketSent} value={dataDisallestimento} onChange={(e) => setDataDisallestimento(e.value)} />} />
                    </>

                }

                {selectedTipoSpaziRichiesti != null && selectedTipoSpaziRichiesti.code == "SE" &&
                    <FormRow left={getText("ALLEGARE_PROGETTO_PRELIMINARE")} right={
                        <div className='col-12 formgroup-inline'>
                            <div className='col-12'>
                                <FileUpload maxFileSize={2500000} disabled={ticketSent} ref={progettoPreliminareFileUploadRef} customUpload uploadHandler={progettoPreliminareBase64Uploader} mode="basic" name="demo[]" accept="pdf/*" />
                            </div>
                            <div className='col-12'>
                                {progettoPreliminare != null && (progettoPreliminare.name + "(" + progettoPreliminare.size + " bytes)")}
                            </div>

                        </div>
                    } />
                }

                <FormRow left={getText("NUMERO_AULE")} right={<InputNumber disabled={ticketSent} min={0} max={100} value={numeroAule} onValueChange={(e) => setNumeroAule(e.value)} />} />
                <FormRow left={getText("NUMERO_PARTECIPANTI_PREVISTI")} right={<InputNumber disabled={ticketSent} min={0} max={100000} value={numeroPartecipantiPrevisti} onValueChange={(e) => setNumeroPartecipantiPrevisti(e.value)} />} />
                <FormRow left={getText("COINVOLTE_ENTITA_ESTERNE")} right={<InputSwitch disabled={ticketSent} checked={coinvolteEntitaEsterne} onChange={(e) => setCoinvolteEntitaEsterne(e.value)} />} />

                {coinvolteEntitaEsterne &&
                    <FormRow left={getText("INDICARE_MODALITA_COINVOLGIMENTO")} right={<InputTextarea disabled={ticketSent} style={{ width: "100%" }} rows={5} cols={50} value={descrizioneEntitaEsterne} onChange={(e) => setDescrizioneEntitaEsterne(e.target.value)} />} />


                }

            </Card>

            <Card title={getText("SPECIFY_IF_REQUESTED")}>
                <div className="formgroup-inline col-12 md:col-12">
                    <div className=" formgroup-inline col-12 md:col-3" style={{ textAlign: "left" }}>
                        <div className='col-9'>
                            {getText("ASSICURAZIONE_MATERIALE_ESPOSTO")}
                        </div>
                        <div className='col-3'>
                            <InputSwitch disabled={ticketSent} checked={assicurazioneMaterialeEsposto} onChange={(e) => setAssicurazioneMaterialeEsposto(e.value)} />
                        </div>
                    </div>
                    <div className=" formgroup-inline col-12 md:col-9" style={{ textAlign: "left" }}>
                        <InputTextarea hidden={!assicurazioneMaterialeEsposto} style={{ width: "100%" }} rows={5} cols={50} value={assicurazioneMaterialeEspostoDesc} onChange={(e) => setAssicurazioneMaterialeEspostoDesc(e.target.value)} />
                    </div>


                    <div className=" formgroup-inline col-12 md:col-3" style={{ textAlign: "left" }}>
                        <div className='col-9'>
                            {getText("ATTREZZATURA_AUDIO_VIDEO")}
                        </div>
                        <div className='col-3'>
                            <InputSwitch disabled={ticketSent} checked={attrezzaturaAudioVideo} onChange={(e) => setAttrezzaturaAudioVideo(e.value)} />
                        </div>
                    </div>
                    <div className=" formgroup-inline col-12 md:col-9" style={{ textAlign: "left" }}>
                        <InputTextarea hidden={!attrezzaturaAudioVideo} style={{ width: "100%" }} rows={5} cols={50} value={attrezzaturaAudioVideoDesc} onChange={(e) => setAttrezzaturaAudioVideoDesc(e.target.value)} />
                    </div>


                    <div className=" formgroup-inline col-12 md:col-3" style={{ textAlign: "left" }}>
                        <div className='col-9'>
                            {getText("ASSISTENZA_AUDIO_VIDEO")}
                        </div>
                        <div className='col-3'>
                            <InputSwitch disabled={ticketSent} checked={assistenzaAudioVideo} onChange={(e) => setAssistenzaAudioVideo(e.value)} />
                        </div>
                    </div>

                    <div className=" formgroup-inline col-12 md:col-9" style={{ textAlign: "left" }}>
                        <InputTextarea hidden={!assistenzaAudioVideo} style={{ width: "100%" }} rows={5} cols={50} value={assistenzaAudioVideoDesc} onChange={(e) => setAssistenzaAudioVideoDesc(e.target.value)} />
                    </div>

                    <div className=" formgroup-inline col-12 md:col-3" style={{ textAlign: "left" }}>
                        <div className='col-9'>
                            {getText("REGISTRAZIONE_EVENTO")}
                        </div>
                        <div className='col-3'>
                            <InputSwitch disabled={ticketSent} checked={registrazioneEvento} onChange={(e) => setRegistrazioneEvento(e.value)} />
                        </div>
                    </div>
                    <div className=" formgroup-inline col-12 md:col-9" style={{ textAlign: "left" }}>
                        <InputTextarea hidden={!registrazioneEvento} style={{ width: "100%" }} rows={5} cols={50} value={registrazioneEventoDesc} onChange={(e) => setRegistrazioneEventoDesc(e.target.value)} />
                    </div>

                    <div className=" formgroup-inline col-12 md:col-3" style={{ textAlign: "left" }}>
                        <div className='col-9'>
                            {getText("CREDENZIALI_WIFI")}
                        </div>
                        <div className='col-3'>
                            <InputSwitch disabled={ticketSent} checked={credenzialiWifi} onChange={(e) => setCredenzialiWifi(e.value)} />
                        </div>
                    </div>
                    <div className=" formgroup-inline col-12 md:col-9" style={{ textAlign: "left" }}>
                        <InputTextarea hidden={!credenzialiWifi} style={{ width: "100%" }} rows={5} cols={50} value={credenzialiWifiDesc} onChange={(e) => setCredenzialiWifiDesc(e.target.value)} />
                    </div>

                    <div className=" formgroup-inline col-12 md:col-3" style={{ textAlign: "left" }}>
                        <div className='col-9'>
                            {getText("PRESIDIO_SORVEGLIANZA")}
                        </div>
                        <div className='col-3'>
                            <InputSwitch disabled={ticketSent} checked={presidioSorveglianza} onChange={(e) => setPresidioSorveglianza(e.value)} />
                        </div>
                    </div>
                    <div className=" formgroup-inline col-12 md:col-9" style={{ textAlign: "left" }}>
                        <InputTextarea hidden={!presidioSorveglianza} style={{ width: "100%" }} rows={5} cols={50} value={presidioSorveglianzaDesc} onChange={(e) => setPresidioSorveglianzaDesc(e.target.value)} />
                    </div>

                    <div className=" formgroup-inline col-12 md:col-3" style={{ textAlign: "left" }}>
                        <div className='col-9'>
                            {getText("PRESIDIO_PULIZIE")}
                        </div>
                        <div className='col-3'>
                            <InputSwitch disabled={ticketSent} checked={presidioPulizie} onChange={(e) => setPresidioPulizie(e.value)} />
                        </div>
                    </div>
                    <div className=" formgroup-inline col-12 md:col-9" style={{ textAlign: "left" }}>
                        <InputTextarea hidden={!presidioPulizie} style={{ width: "100%" }} rows={5} cols={50} value={presidioPulizieDesc} onChange={(e) => setPresidioPulizieDesc(e.target.value)} />
                    </div>

                    <div className=" formgroup-inline col-12 md:col-3" style={{ textAlign: "left" }}>
                        <div className='col-9'>
                            {getText("SERVIZIO_FACCHINAGGIO")}
                        </div>
                        <div className='col-3'>
                            <InputSwitch disabled={ticketSent} checked={servizioFacchinaggio} onChange={(e) => setServizioFacchinaggio(e.value)} />
                        </div>
                    </div>
                    <div className=" formgroup-inline col-12 md:col-9" style={{ textAlign: "left" }}>
                        <InputTextarea hidden={!servizioFacchinaggio} style={{ width: "100%" }} rows={5} cols={50} value={servizioFacchinaggioDesc} onChange={(e) => setServizioFacchinaggioDesc(e.target.value)} />
                    </div>
                </div>

            </Card>
            <div className=" col-12 md:col-12 lg:col-12" >
                {loading && <ProgressSpinner />}
                {!loading &&
                    <>
                        <Button disabled={!validForm() || ticketSent} onClick={sendTicket} className="p-button-primary p-button-rounded" label={getText("SEND_REQUEST")} />&nbsp;&nbsp;
                        {ticketSent &&
                            <Button onClick={createNewTicket} className="p-button-primary p-button-rounded" label={getText("CREATE_NEW_TICKET")} />
                        }
                    </>
                }

            </div>
        </>
    )
}

export default ReactInoltraFormConfig
